import React, { useCallback, useContext, useEffect, useState } from 'react';

import aguid from 'lib/aguid';

import SeriesInput from './SeriesInput';
import V5GadgetFormContext from '../../../contexts/V5GadgetFormContext';

const SeriesInputContainer = () => {
  const {
    series,
    setSeries,
    isMultipleSeriesChart,
    isMultipleYAxisChart,
    draftChart,
  } = useContext(V5GadgetFormContext);
  const [metricIdsToConstrainBy, setMetricIdsToConstrainBy] = useState<
    string[]
  >([]);
  const isAddButtonVisible = series.length === 0 || isMultipleSeriesChart;
  const isMatrix = draftChart?.gadgetType === 'matrix';

  useEffect(() => {
    setMetricIdsToConstrainBy(series.map((s) => s.metricId));
  }, [series]);

  const onAddSeries = useCallback(
    (metric: Metrics.Metric) => {
      setSeries([
        ...series,
        {
          id: aguid(),
          metricId: metric.id,
          smartCardComparison: 'delta',
        },
      ]);
    },
    [series, setSeries],
  );

  const updateSeries = useCallback(
    (newS: V5ChartDefinitionSeries) => {
      setSeries((currentSeries) =>
        currentSeries.map((s) => {
          if (s.id === newS.id) {
            return newS;
          }
          return s;
        }),
      );
    },
    [setSeries],
  );

  const removeSeries = (newS: V5ChartDefinitionSeries) => {
    setSeries(series.filter((s) => s.id !== newS.id));
  };

  const onOrderChanged = useCallback(
    (newOrder: V5ChartDefinitionSeries[]) => {
      setSeries(newOrder);
    },
    [setSeries],
  );

  return (
    <SeriesInput
      isAddButtonVisible={isAddButtonVisible}
      isMultipleYAxisChart={isMultipleYAxisChart}
      isMatrix={isMatrix}
      series={series}
      onAddSeries={onAddSeries}
      updateSeries={updateSeries}
      removeSeries={removeSeries}
      onOrderChanged={onOrderChanged}
      metricIdsToConstrainBy={metricIdsToConstrainBy}
    />
  );
};

export default SeriesInputContainer;
